var map = {
	"./about1.webp": 361,
	"./about2.webp": 221,
	"./about3.webp": 652,
	"./about4.webp": 222,
	"./bg-img-2.webp": 168,
	"./bg-img.webp": 620,
	"./card1.webp": 354,
	"./card2.webp": 34,
	"./card3.webp": 872,
	"./card4.webp": 197,
	"./card5.webp": 362,
	"./card6.webp": 114,
	"./card7.webp": 839,
	"./logo.png": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 330;